import countries from 'i18n-iso-countries';
import { reportErrorToSentry } from '../../../../../../configuration/setup/sentry';

export const getCountryCodes = async (localeFromBrowser: string) => {
    const locale = localeFromBrowser.split('-')[0]?.toLocaleLowerCase();
    let lang = 'en';
    if (langCodes.includes(locale)) {
        lang = locale;
    } else {
        reportErrorToSentry(new Error(`Could not find locale ${localeFromBrowser} for CountryCodeAutoSuggest`));
    }

    // Dynamic import based on language
    const langModule = await localeGetter(lang);

    countries.registerLocale(langModule.default || langModule);
    const names: { [key: string]: string } = countries.getNames(lang, { select: 'official' });
    return Object.entries(names).flatMap(entry => {
        return { code: entry[0], label: entry[1] };
    });
};

const localeGetter = async (localeName: string) => {
    switch (localeName) {
        case 'af':
            return import('i18n-iso-countries/langs/af.json');
        case 'am':
            return import('i18n-iso-countries/langs/am.json');
        case 'ha':
            return import('i18n-iso-countries/langs/ha.json');
        case 'ku':
            return import('i18n-iso-countries/langs/ku.json');
        case 'ml':
            return import('i18n-iso-countries/langs/ml.json');
        case 'no':
            return import('i18n-iso-countries/langs/no.json');
        case 'ps':
            return import('i18n-iso-countries/langs/ps.json');
        case 'sd':
            return import('i18n-iso-countries/langs/sd.json');
        case 'so':
            return import('i18n-iso-countries/langs/so.json');
        case 'sq':
            return import('i18n-iso-countries/langs/sq.json');
        case 'ta':
            return import('i18n-iso-countries/langs/ta.json');
        case 'tg':
            return import('i18n-iso-countries/langs/tg.json');
        case 'tt':
            return import('i18n-iso-countries/langs/tt.json');
        case 'ug':
            return import('i18n-iso-countries/langs/ug.json');
        case 'ur':
            return import('i18n-iso-countries/langs/ur.json');
        case 'vi':
            return import('i18n-iso-countries/langs/vi.json');
        case 'ar':
            return import('i18n-iso-countries/langs/ar.json');
        case 'az':
            return import('i18n-iso-countries/langs/az.json');
        case 'be':
            return import('i18n-iso-countries/langs/be.json');
        case 'bg':
            return import('i18n-iso-countries/langs/bg.json');
        case 'bn':
            return import('i18n-iso-countries/langs/bn.json');
        case 'bs':
            return import('i18n-iso-countries/langs/bs.json');
        case 'ca':
            return import('i18n-iso-countries/langs/ca.json');
        case 'cs':
            return import('i18n-iso-countries/langs/cs.json');
        case 'da':
            return import('i18n-iso-countries/langs/da.json');
        case 'de':
            return import('i18n-iso-countries/langs/de.json');
        case 'el':
            return import('i18n-iso-countries/langs/el.json');
        case 'en':
            return import('i18n-iso-countries/langs/en.json');
        case 'es':
            return import('i18n-iso-countries/langs/es.json');
        case 'et':
            return import('i18n-iso-countries/langs/et.json');
        case 'fa':
            return import('i18n-iso-countries/langs/fa.json');
        case 'fi':
            return import('i18n-iso-countries/langs/fi.json');
        case 'fr':
            return import('i18n-iso-countries/langs/fr.json');
        case 'gl':
            return import('i18n-iso-countries/langs/gl.json');
        case 'he':
            return import('i18n-iso-countries/langs/he.json');
        case 'hi':
            return import('i18n-iso-countries/langs/hi.json');
        case 'hr':
            return import('i18n-iso-countries/langs/hr.json');
        case 'hu':
            return import('i18n-iso-countries/langs/hu.json');
        case 'hy':
            return import('i18n-iso-countries/langs/hy.json');
        case 'id':
            return import('i18n-iso-countries/langs/id.json');
        case 'is':
            return import('i18n-iso-countries/langs/is.json');
        case 'it':
            return import('i18n-iso-countries/langs/it.json');
        case 'ja':
            return import('i18n-iso-countries/langs/ja.json');
        case 'ka':
            return import('i18n-iso-countries/langs/ka.json');
        case 'kk':
            return import('i18n-iso-countries/langs/kk.json');
        case 'km':
            return import('i18n-iso-countries/langs/km.json');
        case 'ko':
            return import('i18n-iso-countries/langs/ko.json');
        case 'ky':
            return import('i18n-iso-countries/langs/ky.json');
        case 'lt':
            return import('i18n-iso-countries/langs/lt.json');
        case 'lv':
            return import('i18n-iso-countries/langs/lv.json');
        case 'mk':
            return import('i18n-iso-countries/langs/mk.json');
        case 'mn':
            return import('i18n-iso-countries/langs/mn.json');
        case 'ms':
            return import('i18n-iso-countries/langs/ms.json');
        case 'nb':
            return import('i18n-iso-countries/langs/nb.json');
        case 'nl':
            return import('i18n-iso-countries/langs/nl.json');
        case 'nn':
            return import('i18n-iso-countries/langs/nn.json');
        case 'pl':
            return import('i18n-iso-countries/langs/pl.json');
        case 'pt':
            return import('i18n-iso-countries/langs/pt.json');
        case 'ro':
            return import('i18n-iso-countries/langs/ro.json');
        case 'ru':
            return import('i18n-iso-countries/langs/ru.json');
        case 'sk':
            return import('i18n-iso-countries/langs/sk.json');
        case 'sl':
            return import('i18n-iso-countries/langs/sl.json');
        case 'sr':
            return import('i18n-iso-countries/langs/sr.json');
        case 'sv':
            return import('i18n-iso-countries/langs/sv.json');
        case 'th':
            return import('i18n-iso-countries/langs/th.json');
        case 'tr':
            return import('i18n-iso-countries/langs/tr.json');
        case 'uk':
            return import('i18n-iso-countries/langs/uk.json');
        case 'uz':
            return import('i18n-iso-countries/langs/uz.json');
        case 'zh':
            return import('i18n-iso-countries/langs/zh.json');
        default:
            return import('i18n-iso-countries/langs/en.json');
    }
};

const langCodes = [
    'af',
    'am',
    'ha',
    'ku',
    'ml',
    'no',
    'ps',
    'sd',
    'so',
    'sq',
    'ta',
    'tg',
    'tt',
    'ug',
    'ur',
    'vi',
    'ar',
    'az',
    'be',
    'bg',
    'bn',
    'bs',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'en',
    'es',
    'et',
    'fa',
    'fi',
    'fr',
    'gl',
    'he',
    'hi',
    'hr',
    'hu',
    'hy',
    'id',
    'is',
    'it',
    'ja',
    'ka',
    'kk',
    'km',
    'ko',
    'ky',
    'lt',
    'lv',
    'mk',
    'mn',
    'ms',
    'nb',
    'nl',
    'nn',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sl',
    'sr',
    'sv',
    'th',
    'tr',
    'uk',
    'uz',
    'zh',
];
